import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import AffichageSelctDate, {
  sorteGroupeActivity,
} from "../inscriptionWish/ChoixDates/AfficheDateSelected";
import rest from "../../rest";
import ButtonConfirm from "../general/ButtonConfirm";
import { IconButton, Tooltip } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import { MySnackbar } from "../mySnackbar/MySnackbar";
import { useSelector } from "react-redux";

const LegendTooltip = () => {
  return (
    <Tooltip
      title={
        `Cette action réinitialise les souhaits du bénévole et le retire des attributions, 
              quel que soit son statut. Son compte en ligne restera actif, 
              mais il devra sélectionner de nouveaux souhaits s'il souhaite participer à l'édition en cours.`
      }
      arrow
    >
      <IconButton>
        <InfoIcon fontSize="small" style={{ color: '#fff' }} />
      </IconButton>
    </Tooltip >
  );
};

const OngletWish = ({ idBenevole }) => {
  const [groupedActivities, setGroupedActivities] = useState({});
  const [activitesInfos, setActivitesInfos] = useState([]);
  const [snack, setSnack] = useState({});
  const currentUser = useSelector((state) => state.user);

  useEffect(() => {
    rest
      .post("/benevols/planning.json", { vID: idBenevole })
      .then((response) => {
        setGroupedActivities(sorteGroupeActivity(response.data.tranches));
        setActivitesInfos(response.data.choixActivites);
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
      });
  }, [idBenevole]);

  const handDeletWish = () => {
    rest
      .post("/benevols/deleteWishList.json", { vID: idBenevole })
      .then((response) => {
        setSnack({ message: response?.data?.message, show: true, severity: "success" });
        setActivitesInfos([]);
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
      });
  }

  return (
    <div>
      <MySnackbar params={snack} />
      <Grid container>
        <Grid item xs={12} sm={3} style={{ width: "100%", maxWidth: "100%", minWidth: "100%" }} >
        {currentUser.User.User_Administrator && activitesInfos?.length > 0 && <ButtonConfirm
            onConfirm={handDeletWish}
            text={<>suprimer les souhaits du bénévole <LegendTooltip /></>}
            textConfirm="Confirmer suppression"
            variant="contained"
            color="errorBtn"
            style={{ marginRight: 10 }}
          />}
          {activitesInfos?.length > 0 && <AffichageSelctDate
            activitesInfos={activitesInfos}
            groupedActivities={groupedActivities}
          />}
        </Grid>
      </Grid>
    </div>
  );
};

export default OngletWish;
